export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_USER_INFOS = 'SET_USER_INFOS';
export const SET_COMPANY_INFOS = 'SET_COMPANY_INFOS';
export const SET_SELECTED_COMPANY = 'SET_SELECTED_COMPANY';
export const SET_SELECTED_PROJECT = 'SET_SELECTED_PROJECT';
export const RESET_APP_STATE = 'RESET_APP_STATE';
export const SET_STATE = 'SET_STATE';
export const SET_COMPANIES = 'SET_COMPANIES';